// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2025 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import PaginationBackToTop from "@synd/XDL/Icons/TopAnchorButtonArrowUp";
import breakpoints from "@synd/XDL/PreStyle/breakpoints";
import Clickable from "@insite/mobius/Clickable";
import Icon from "@insite/mobius/Icon";
import React, { FC, useEffect, useState } from "react";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";

interface OwnProps {}

type Props = OwnProps;

const padding = (breakpoints as any).paddingValues[0];
const maxPageWidth = breakpoints.maxWidths[breakpoints.maxWidths.length - 2];
const maxPageWidthLg = breakpoints.maxWidths[breakpoints.maxWidths.length - 1];
interface BackToTopStyles {
    backToTopBtn?: InjectableCss;
}
export const backToTopStyles: BackToTopStyles = {};

const BackToTop: FC<Props> = () => {
    const [visible, setVisible] = useState(false);
    const styles = backToTopStyles;

    useEffect(() => {
        const handleScroll = () => {
            const newVisible = document.body.scrollTop > 50 || document.documentElement.scrollTop > 50;
            setVisible(newVisible);
        };
        if (typeof window !== "undefined") {
            window.addEventListener("scroll", handleScroll, { passive: true });

            return () => {
                window.removeEventListener("scroll", handleScroll);
            };
        }
    }, []);

    const handleBackToTop = () => {
        window.scrollTo({
            left: 0,
            top: 0,
            behavior: "smooth",
        });
    };

    return (
        <Clickable
            {...styles.backToTopBtn}
            id="backToTop"
            aria-label="Back To Top"
            onClick={handleBackToTop}
            {...{
                visible,
            }}
        >
            <Icon src={PaginationBackToTop} size={36} />
        </Clickable>
    );
};

export default BackToTop;
